export const boxes = [
    {
        title: "Education",
        isYear: true,
        content: [
            {
                year: "1992",
                text: "Graduated from Samara Medical Institute",
            },
            {
                year: "2012",
                text: "Defended his Ph.D. dissertation on the topic of implementing positive motivation methods for forming a healthy lifestyle",
            },
            {
                year: "10+ years",
                text: "Studied ancient Ayurveda practices in India",
            },
        ],
    },
    {
        title: "Achievements",
        isYear: true,
        content: [
            {
                year: "2011",
                text: "The International Academy of Sobriety awarded him the academic title of professor for his merits in sobering the nation",
            },
            {
                year: "2014",
                text: "Received a letter of gratitude from the Government for his dedicated activities in the spiritual, moral, and physical health of the country",
            },
            {
                year: "2015",
                text: "Awarded the Mechnikov gold medal by the Russian Academy of Natural Sciences (RAEN) for his contribution to strengthening the nation’s health",
            },
        ],
    },
    {
        title: "Experience",
        isYear: false,
        content: [
            {
                text: "For more than 20 years, he has been giving lectures in the CIS countries, Europe, and the USA, and has appeared on radio and television.",
            },
            {
                text: "Opened the «Amrita» wellness center, the «Saraswati» educational center, and created an online resource with lectures — «Veda-radio.»",
            },
            {
                text: "Promotes the creation of «Good People» clubs and participates in festivals and retreats aimed at the moral development of people.",
            },
        ],
    },
    {
        title: "Publications",
        isYear: false,
        content: [
            {
                text:
                    "2011\n" +
                    "The book series «Good Advice from Dr. Torsunov,» «Development of Intelligence,» and «The Laws of a Happy Life» have gained high popularity. Over 30 books have been published in total.",
            },
            {
                text: "Dr. Torsunov’s articles on healing methods using reflexology and crystal therapy have found a positive response in scientific circles.",
            },
            {
                text: "In 2018, he was awarded the «For the Good of the World» prize in the educational literature category (for the book «The Subtle Structure of Man»).",
            },
        ],
    },
];
